import { useMemo } from 'react';

import { useMarketNavigator } from './useMarketNavigator';
import { useGoodsNavigator } from './useGoodsNavigator';
import { useCommonNavigator } from './useCommonNavigator';
import { useReviewsNavigator } from './useReviewsNavigator';
import { useScreensNavigator } from './useScreensNavigator';

export const useNavigator = () => {
  const { moveToMarketHome } = useMarketNavigator();
  const { moveToGoods, moveToRecentlyViewedGoods, moveToRankingGoods } =
    useGoodsNavigator();
  const {
    moveToWebview,
    moveToToday,
    moveToSearch,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
  } = useCommonNavigator();
  const { moveToPhotoReviewList, moveToReviewList } = useReviewsNavigator();
  const { moveToFragmentScreens } = useScreensNavigator();

  const navigator = useMemo(
    () => ({
      moveToWebview,
      moveToHome,
      moveToRecentlyViewedGoods,
      moveToMarketHome,
      moveToRankingGoods,
      moveToGoods,
      moveToSearch,
      moveToToday,
      moveToLikeFolders,
      moveToScreens,
      moveToPhotoReviewList,
      moveToReviewList,
      moveToFragmentScreens,
    }),
    [
      moveToWebview,
      moveToHome,
      moveToRecentlyViewedGoods,
      moveToMarketHome,
      moveToRankingGoods,
      moveToGoods,
      moveToSearch,
      moveToToday,
      moveToLikeFolders,
      moveToScreens,
      moveToPhotoReviewList,
      moveToReviewList,
      moveToFragmentScreens,
    ],
  );

  return { navigator };
};
